import { render } from "./ProgramCreateGeneral.vue?vue&type=template&id=644fb392"
import script from "./ProgramCreateGeneral.vue?vue&type=script&lang=js"
export * from "./ProgramCreateGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__